import { React, useState, useEffect } from "react";
import { connect } from "react-redux";
import { Box, CircularProgress, Stack, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as actionType from "../../store/actions";
import { Amplify } from "aws-amplify";
import { fetchAuthSession, signOut } from "aws-amplify/auth";
import {
  Authenticator,
  useTheme,
  View,
  Heading,
  Button,
  useAuthenticator,
  ThemeProvider,
  Theme
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { fetchAndStoreAWSTemporaryCredentails } from "../../shared/components/SignApi";
import jwt_decode from "jwt-decode";

import {
  AWS_USER_LOGIN_CLIENT_ID,
  AWS_USER_POOL_ID
} from "../../shared/constants/cognitoConstants";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: AWS_USER_LOGIN_CLIENT_ID,
      userPoolId: AWS_USER_POOL_ID
    }
  }
});

const AuthenticatorUserSetter = ({ user, onUserChange }) => {
  useEffect(() => {
    if (onUserChange) {
      onUserChange(user ?? {});
    }
  }, [user, onUserChange]);
  return null;
};

const AuthorizationAccess = (props) => {
  const { actions, personData, personDataLoading } = props;
  const [authUserData, setUserData] = useState({});
  const [token, setToken] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [isFirstLogin, setFirstLogin] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loginUserType, setLoginUserType] = useState("");
  const [impersonatorId, setImpersonatorId] = useState("");
  const [cognitoUserId, setCongnitoUserId] = useState("");
  const navigate = useNavigate();
  const loginUrl = window.location.href;
  let tokenId = loginUrl.split("/#")[1];
  let getUrl = new URL(loginUrl);
  let pathandQuery = getUrl.pathname + getUrl.search;

  const theme: Theme = {
    name: "Auth Example Theme",
    tokens: {
      components: {
        button: {
          // this will affect the font weight of all button variants
          fontWeight: { value: "{fontWeights.normal}" },
          backgroundColor: { value: "#1BA3AD" },
          borderColor: { value: "#1BA3AD" },
          color: { value: "#fff" }
        }
      }
    }
  };
  // localhost:3001/#id_token=eyJraWQiOiI1N3p4RzV4cjNCcVwvZ3hDeDY5YkhcLzdza2lTVzdTdE9oVnNwMTlUZ1pLQ1U9IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiI1MGRjM2U0YS02MjZhLTRhYmYtOTA0NC1mZDIxZTA0MDIwZjciLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0xLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMV96WWxtZWlOSWsiLCJjb2duaXRvOnVzZXJuYW1lIjoiNTBkYzNlNGEtNjI2YS00YWJmLTkwNDQtZmQyMWUwNDAyMGY3IiwiY3VzdG9tOnBhdGllbnRfcCI6IjpzcmdwdHA6cHRocDpmZTpweWI6ZGM6bWU6cGY6Iiwib3JpZ2luX2p0aSI6IjhiOGJiODQ0LWFjYTktNGUwMC05OGM0LTIyNWRjMjk3MWFkNCIsImF1ZCI6IjEzNGZnaDgyNm9iZTczcDZtNjh0cDJya3M5IiwidG9rZW5fdXNlIjoiaWQiLCJhdXRoX3RpbWUiOjE3MDQ4ODQwMTcsIm5hbWUiOiJNYW5pc2giLCJleHAiOjE3MDQ4ODc2MTcsImlhdCI6MTcwNDg4NDAxNywiZmFtaWx5X25hbWUiOiJLdW1hd2F0IiwianRpIjoiZjI4MjkzMzUtOWIyOC00YTJjLTgxYTgtMTY4ZTMzYjE3NDM0IiwiZW1haWwiOiJtYW5pc2guYmFsb2RpYUBmZXhsZS5jb20ifQ.f9bTshIx6KuopPRuiW-eiEuw-zLQQDfLekDvc5LLeA22ZRiMn3bszz7xoqk0rl52tl5Mn2resO_4XNSsioVQAop5QS_a_TKAuPzri1cIAKKoUYlVbgOGBVdMFLEbi8W85WdJv0fNo-_2SBZ-dxKpcBWq_7MxcD6Wsct4qaf83r0YxR_hLQtmxTMuAv2fYnrXycK6oXOQybyfP--KeI8azRm2JkrhJJMISIzfYAYlqG0STjeV4aGxjhGeUVGQY9WUAgho5OmdNCwlyp3q2r7B3vzaEeBhpaGB_WfDU87axi-7si6soa81OglffjhnsBMn9Ve-2FRar_EnpHIpPpxNRg&access_token=eyJraWQiOiJSaVdwb1BQTE5cL2JETmVcL3hXTWliaDUzXC9QUWs5UzVkMVwvR2xFQlpVa0JEWT0iLCJhbGciOiJSUzI1NiJ9.eyJvcmlnaW5fanRpIjoiOGI4YmI4NDQtYWNhOS00ZTAwLTk4YzQtMjI1ZGMyOTcxYWQ0Iiwic3ViIjoiNTBkYzNlNGEtNjI2YS00YWJmLTkwNDQtZmQyMWUwNDAyMGY3IiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTcwNDg4NDAxNywiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tXC91cy1lYXN0LTFfellsbWVpTklrIiwiZXhwIjoxNzA0ODg3NjE3LCJpYXQiOjE3MDQ4ODQwMTcsImp0aSI6ImNmY2FjMTEzLTZlNGEtNDQ3MS04ZmZlLTM4MTVjODhjNjE2MCIsImNsaWVudF9pZCI6IjEzNGZnaDgyNm9iZTczcDZtNjh0cDJya3M5IiwidXNlcm5hbWUiOiI1MGRjM2U0YS02MjZhLTRhYmYtOTA0NC1mZDIxZTA0MDIwZjcifQ.KYGgnI_IKkNIzLjYYnuB3xbLcIO18OCBbHfwLCtiyBOplK_R7UlCK9WcD95lwUFNgBHm3ZeF4JJOuZ_qjZZ-4W7LFzTZPwSdl_FHjvbgMhiuCoweRHs8xWrplc8IVqGKXE_KwyNoqsCOZBqlUWfWeKGFdGIyL_A6WfM0EFvMBIEEK_CsycaBytSEhG0xRf-ASsTQalwldRBxkopTm2smKRwLk_ndcXMlVAesdZnnQrfMFqIxunyilzbrShbX7t1tDVnXCxI48M_rsXnlOSmBDT0O1Rc9Mk7T1gP7fdmC9DMCy9BM901meUlsC9Aa7uNy61SXh9rfyncekqYvTHd6QQ&user_id=50dc3e4a-626a-4abf-9044-fd21e04020f7&login_by=admin&impersonatorId=68d20931-10f4-4779-896b-e5dacfceb373

  useEffect(() => {
    let checkloginByadmin = tokenId && tokenId.split("&");
    let isLoginBy = "";
    if (checkloginByadmin && checkloginByadmin.length > 0) {
      checkloginByadmin.forEach((tokenValues) => {
        if (tokenValues.includes("login_by")) {
          isLoginBy = "admin";
          setLoginUserType(isLoginBy);
        } else if (tokenValues.includes("impersonatorId")) {
          let impersonateData = tokenValues.split("=");
          if (impersonateData && impersonateData[1]) setImpersonatorId(impersonateData[1]);
        } else if (tokenValues.includes("congnitoUserId")) {
          let congnitoUserIdData = tokenValues.split("=");
          if (congnitoUserIdData && congnitoUserIdData[1]) setCongnitoUserId(congnitoUserIdData[1]);
        }
      });
    } else {
      setLoginUserType("patient");
    }
    if (isLoginBy === "admin") {
      localStorage.clear();
      tokenId =
        localStorage.getItem("tokenId") !== "undefined" && localStorage.getItem("tokenId")
          ? localStorage.getItem("tokenId")
          : tokenId;

      if (tokenId || localStorage.getItem("email")) {
        localStorage.setItem("tokenId", tokenId);

        let paramString = tokenId; //window.location.href.split("/#")[1];

        let tokenDetails = "";
        let tokenDetailsSplit = "";
        tokenDetailsSplit = paramString !== undefined && paramString.split("&");
        let idTokenIndex = "";

        if (tokenDetailsSplit.length > 0) {
          tokenDetailsSplit.forEach((tokenValues, index) => {
            if (tokenValues.includes("id_token")) {
              idTokenIndex = index;
            }
          });
        }

        let queryString =
          paramString !== undefined
            ? new URLSearchParams(paramString.split("&")[idTokenIndex])
            : [];
        for (let pair of queryString.entries()) {
          tokenDetails = pair[1];
        }
        let token = tokenDetails.split("&")[0];

        let decodedToken = jwt_decode(token);

        localStorage.setItem("email", decodedToken.email);
        setUserEmail(decodedToken.email);
        setToken(token);
        fetchAndStoreAWSTemporaryCredentails(token).then(() => {
          if (Object.keys(personData).length == 0) {
            actions.getPersonData({ email: decodedToken.email });
          }
        });
      }
    }
  }, []);

  const currentSession = async () => {
    let tokenID = "";
    try {
      //const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
      let tokenId = idToken && idToken.toString();

      if (tokenId) {
        setToken(tokenId);
        tokenID = tokenId;
      }
    } catch (err) {
      console.log("eoor", err);
    }
    return tokenID;
  };

  useEffect(() => {
    if (Object.keys(authUserData).length > 0) {
      const email =
        (authUserData && authUserData.signInDetails && authUserData.signInDetails.loginId) || "";

      if (email) {
        currentSession();
        setUserEmail(email);
      } else {
        signOut();
        localStorage.clear();
        setFirstLogin(false);
      }
    }
  }, [authUserData]);

  useEffect(() => {
    if (userEmail && token) {
      fetchAndStoreAWSTemporaryCredentails(token)
        .then(() => {
          if (Object.keys(personData).length == 0 && isFirstLogin === false) {
            actions.getPersonData({ email: userEmail });
            setFirstLogin(true);
          }
        })
        .catch((err) => {
          console.log("authentication error", err.message);
          setErrorMessage(err.message);
          setFirstLogin(false);
        });
    }
  }, [userEmail, token]);

  useEffect(() => {
    if (Object.keys(personData).length > 0) {
      console.log("personData", personData);
      localStorage.setItem("patientId", personData.personId);
      localStorage.setItem("practiceId", personData.practiceId);
      localStorage.setItem("isFirtLogin", personData.firstLogin);
      localStorage.setItem("email", userEmail);
      localStorage.setItem("tokenId", token);

      if (impersonatorId) localStorage.setItem("impersonatorId", impersonatorId);
      if (cognitoUserId) localStorage.setItem("cognitoUserId", cognitoUserId);

      // actions.getUserList({
      //   email: personData.email,
      //   practiceId: personData.practiceId,
      //   primaryRole: "Patient"
      // });

      if (pathandQuery === "/initial-registration") {
        navigate("/initial-registration", { replace: true });
      } else {
        navigate("/home", { replace: true });
        //window.location.href = "/home";
      }
    }
  }, [personData]);
  // useEffect(() => {
  //   console.log("userData", userData);
  //   if (userData.length > 0) {
  //     localStorage.setItem("userId", userData[0].userId);
  //   }
  // }, [userData]);

  useEffect(() => {
    if (props.error) {
      setErrorMessage(props.error);
      signOut();
      localStorage.clear();
      setFirstLogin(false);
    } else if (errorMessage) {
      setErrorMessage(errorMessage);
      signOut();
      localStorage.clear();
      setFirstLogin(false);
    }
  }, [errorMessage, props.error]);

  const formFields = {
    signIn: {
      username: {
        placeholder: "Enter your Email Address"
      }
    },
    forgotPassword: {
      username: {
        placeholder: "Enter your Email Address"
      }
    }
  };
  return (
    <Box>
      {personDataLoading ? (
        <Stack justifyContent="center" p={5} alignItems="center">
          <CircularProgress size={50} />
        </Stack>
      ) : loginUserType === "admin" ? (
        <Stack justifyContent="center" p={5} alignItems="center">
          <CircularProgress size={50} />
        </Stack>
      ) : loginUserType === "patient" ? (
        <>
          <ThemeProvider theme={theme}>
            <Authenticator
              hideSignUp={true}
              variation="modal"
              formFields={formFields}
              components={{
                SignIn: {
                  Header() {
                    const { tokens } = useTheme();

                    return (
                      <>
                        <Heading padding={`${tokens.space.xl}`} level={3}>
                          Sign in to your account
                        </Heading>
                        <div style={{ marginTop: 5 }}>
                          {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
                        </div>
                      </>
                    );
                  },
                  Footer() {
                    const { toForgotPassword } = useAuthenticator();
                    const navigate = useNavigate();
                    return (
                      <View
                        className="amplify-flex"
                        style={{
                          flexDirection: "column",
                          marginLeft: 30,
                          marginRight: 30,
                          marginBottom: 20
                        }}>
                        <Button
                          fontWeight="normal"
                          onClick={toForgotPassword}
                          size="small"
                          variation="link"
                          color={"#1BA3AD"}>
                          Forgot Your Password?
                        </Button>
                        <Button
                          class="amplify-button amplify-field-group__control amplify-button--primary amplify-button--fullwidth"
                          fontWeight="normal"
                          onClick={() => {
                            navigate("/initial-registration", { replace: true });
                          }}
                          size="small"
                          variation="link">
                          Register
                        </Button>
                      </View>
                    );
                  }
                }
              }}>
              {({ user }) => {
                return (
                  <>
                    <AuthenticatorUserSetter user={user} onUserChange={setUserData} />
                    <div>
                      {/* <p>Welcome {user?.username}</p>
                  <button onClick={signOut}>Sign out</button> */}
                    </div>
                  </>
                );
              }}
            </Authenticator>
          </ThemeProvider>
        </>
      ) : (
        <Stack justifyContent="center" p={5} alignItems="center">
          <CircularProgress size={50} />
        </Stack>
      )}
    </Box>
  );
};

const mapStateToProps = ({ homeReducer }) => {
  return {
    personData: homeReducer.personData,
    userData: homeReducer.userList,
    personDataLoading: homeReducer.personDataLoading,
    error: homeReducer.error
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: {
    getPersonData: (payload) => {
      dispatch(actionType.getPersonData(payload));
    },
    getUserList: (payload) => {
      dispatch(actionType.getUserList(payload));
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthorizationAccess);
